export default function DateTimeText({ value }) {
  if (!value) return '-';
  const date = new Date(value.replace(' ', 'T'));
  if (isNaN(date.getTime())) return value;
  const formattedDate = date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
  return (
    <span>
      {formattedDate} {formattedTime}
    </span>
  );
}